import type {
  VisualPromptAnswers,
  VisualPromptAnswerValue,
  VisualPromptStep,
} from '@/types/visualPrompts/visualPrompt.types';

const isEmptyValue = (value: VisualPromptAnswerValue | undefined): boolean => {
  if (value === undefined) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return String(value).trim() === '';
};

export const isStepAnswerValid = (
  step: VisualPromptStep,
  answers: VisualPromptAnswers,
): boolean => {
  if (step.type === 'review') {
    return true;
  }
  if (!step.required) {
    return true;
  }
  return !isEmptyValue(answers[step.mapsTo]);
};

export const validateWizardStep = (
  step: VisualPromptStep,
  answers: VisualPromptAnswers,
): { valid: boolean; message?: string } => {
  if (isStepAnswerValid(step, answers)) {
    return { valid: true };
  }
  return { valid: false, message: 'Please complete this step before continuing.' };
};
